// eslint-disable-next-line no-restricted-imports
import CommentBankOutlinedIcon from '@mui/icons-material/CommentBankOutlined';
import { iconFontSize } from 'themes';

export default function TemplateIcon(props: any) {
  const { spacingTop = 0, ...rest } = props;
  return <CommentBankOutlinedIcon {...rest} sx={{ fontSize: iconFontSize, height: 16, width: 16, mt: spacingTop }} />;
}
